// react-magnetic-di - temporary comment, for auto dependency injection in tests
import { useCallback, useRef } from 'react';
import { useCurrentFormState } from '../../../../../../../../controllers/issue-adjustments/hooks/use-current-form-state';
import { useViewType } from '../../../../../../../../controllers/issue-adjustments/hooks/use-view-type';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { filterFieldsChangesBasedOnScopes } from '../../utils/filter-based-on-scopes/form-data';
export var useFilterFieldChangesBasedOnScope = function useFilterFieldChangesBasedOnScope(moduleScopes) {
  var _useCurrentFormState = useCurrentFormState(),
    currentFormState = _useCurrentFormState.currentFormState;
  var currentFormStateRef = useRef(currentFormState);
  var viewType = useViewType();

  /**
   * We want to have an up-to-date data when this hook's
   * returned function is being called in useSubmit callback function
   * thats why we keep it in a ref object
   */
  currentFormStateRef.current = currentFormState;
  return useCallback(function (fieldChanges) {
    return filterFieldsChangesBasedOnScopes(fieldChanges, currentFormStateRef.current, viewType, moduleScopes);
  }, [moduleScopes, viewType]);
};